module.exports = __webpack_public_path__ + "img/bm.8ce2ca96.png";